import {Component, Input, AfterViewInit, ViewChild, ElementRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environments';
import {CheckoutHelperService} from '../../../../Services/BuissnessLogic/Checkout/checkout-helper.service';
import {Router} from '@angular/router';
import {FormGroup} from '@angular/forms';
import {PaypalService} from '../../../../Services/BuissnessLogic/Paypal/paypal.service';
import {AuthService} from '../../../../Services/BuissnessLogic/auth.service';

@Component({
    selector: 'app-paypal-button',
    standalone: true,
    imports: [],
    templateUrl: './paypal-button.component.html',
    styleUrl: './paypal-button.component.scss'
})
export class PayPalButtonComponent implements AfterViewInit {
    @Input() orderId!: string;
    @Input() checkoutForm!: FormGroup;
    @Input() submitted!: boolean;
    @Input() markAllAsTouched!: () => void;
    @ViewChild('paypalButtonContainer', { static: true }) paypalButtonContainer!: ElementRef;

    constructor(
        private checkoutHelperService: CheckoutHelperService,
        private paypalService: PaypalService,
        private router: Router,
        private auth: AuthService,
    ) {}

    ngAfterViewInit() {
        if (!(window as any).paypal) {
            console.error('PayPal SDK not loaded');
            return;
        }

        (window as any).paypal.Buttons({
            onClick: (data: any, actions: any) => {
                if (this.checkoutForm.invalid) {
                    this.markAllAsTouched();
                    return actions.reject();
                }
                return actions.resolve();
            },
            createOrder: async (data: any, actions: any) => {
                // 1. Send purchase info to backend
                const purchaseInfo = await this.checkoutHelperService
                    .sendPurchaseInfoToBackend(this.checkoutForm.value, 'Paypal')
                    .toPromise();

                const orderId = purchaseInfo?.orderId || this.orderId;
                this.orderId = orderId;

                // 2. Create order with PayPal
                const paypalOrder = await this.paypalService.createOrder(orderId).toPromise();
                return paypalOrder?.paypalOrderId;
            },
            onApprove: async (data: any, actions: any) => {
                const capture = await this.paypalService.captureOrder(this.orderId, data.orderID).toPromise();
                if (capture?.success) {
                    if (!this.auth.isLoggedIn()) {
                        this.router.navigate(["/thank-you-paypal"]);
                    } else {
                        this.router.navigate(["/profil"]);
                    }
                } else {
                    alert('Payment failed or could not be verified.');
                }
            },
            onError: (err: any) => {
                console.error('PayPal error', err);
                alert('Something went wrong with the payment.');
            }
        }).render(this.paypalButtonContainer.nativeElement);
    }
}